<template>
  <div id="app">
    <the-header/>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {
    TheHeader: () => import('@/components/TheHeader.vue')
  }
}
</script>

<style lang="sass">
  $body-background-color: #f4f4f4;

  @import "bulma/bulma.sass";
</style>

<style lang="scss">
  :root {
    --error-color: #ff3860;
    --primary-blue: #007ebf;
    --primary-green: #00b00c;
  }

  html,
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto !important;
    background-color: #f2f3f5;
    font-family: 'Source Sans Pro', sans-serif;
  }

  #app {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
  }

  #app > .hero {
    flex: 1;
  }

  .button[disabled], fieldset[disabled] .button, .button[disabled]:hover {
    background-color: white;
    border-color: #dbdbdb;
    box-shadow: none;
    opacity: 0.5;
    color: black;
  }
  .button_ibs {
    background-color: var(--primary-green);
    border: 1px solid var(--primary-green);
    opacity: 0.79;
    color: white;
    transition: opacity 0.5s ease-in-out;
    padding-top: 1.3rem;
    padding-bottom: 1.3rem;
    font-weight: 600;
  }
  .button_ibs.sm_btn {
    font-size: 14px;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .button_ibs:hover,
  .button_ibs:active,
  .button_ibs:focus,
  .button_ibs:visited,
  .button_ibs.is-active,
  .button_ibs.is-visited {
    border: 1px solid var(--primary-green);
    opacity: 1;
    color: white;
  }
  ::placeholder {
    color: #5d6990;
    font-weight: 600;
  }
</style>
